export default __webpack_public_path__ + "static/media/student-circle.9285541e.png";